import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, inject } from '@angular/core'
import {
	MatDialog,
	MatDialogRef,
	MatDialogTitle,
	MatDialogClose,
	MatDialogContent,
	MatDialogActions,
} from '@angular/material/dialog'
import { LoadingService } from '../../core/services/loading.service'
import { Notification } from '../../../../domain/notification.model'
import { AbstractTableComponent } from '../table/abstract-table-component'
import { ColDef } from '../modules/table/col-def.model'
import { DateColumn, TextColumn } from '../modules/table/columns'
import { SnackbarService } from 'src/app/core/services/snackbar.service'
import { FirestoreService } from '../modules/fire/firestore.service'
import { AuthService } from 'src/app/modules/auth/auth.service'
import { MatSortable, Sort } from '@angular/material/sort'
import { FirestoreFilter } from '../modules/fire/firestore/list/firestore-filter'
import { NotificationsFirestoreService } from 'src/app/core/firestore-services/notifications-firestore.service'
import { UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms'
import {
	OptionSelectedEvent,
	SelectComponent,
	SelectOptionTemplateDirective,
} from '../modules/form/select/select.component'
import { MatButton } from '@angular/material/button'
import { MatIcon } from '@angular/material/icon'
import { CdkScrollable } from '@angular/cdk/scrolling'
import { FmxFormSubmitDirective } from '../modules/form/submit/form-submit.directive'
import { FmxControlSubmitDirective } from '../modules/form/submit/control-submit.directive'
import { TableComponent } from '../modules/table/table.component'
import { FirestorePaginatorComponent } from '../modules/fire/firestore/firestore-paginator.component'
import { AsyncPipe } from '@angular/common'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
	selector: 'app-notification-panel-dialog',
	template: `
		<div matDialogTitle style="display: flex;justify-content: space-between;align-items: center;margin-bottom:0px;">
			<h1 style="margin-top:16px">{{ 'obiect.notificari' | translate }}</h1>
			<button mat-button mat-dialog-close (click)="close()">
				<mat-icon class="btn-custom-default">cancel</mat-icon>
			</button>
		</div>
		<mat-dialog-content>
			<div [formGroup]="sortSelectionForm">
				<div class="flex-63"></div>
				<app-select
					style="border-radius:4px;"
					[items]="sortSelection"
					panelClass="mat-select-notification-dropdown"
					valueProperty="sort"
					formControlName="order"
					class="flex-33"
					(optionSelectionChange)="onSortSelect($event)"
					><ng-template appSelectOption let-sort>{{ sort.text }}</ng-template></app-select
				>
			</div>
			<app-table
				[dataSource]="dataSource"
				[columns]="columns"
				[defaultSort]="defaultSort"
				[omitHeaders]="omitHeaders"
				(sort)="onSort($event)"
			>
			</app-table>
			<app-firestore-paginator [pageSize]="pageSize" [disabled]="(dataSource.loading$ | async)!">
			</app-firestore-paginator>
		</mat-dialog-content>
		<div mat-dialog-actions></div>
	`,
	styleUrls: ['./notification-panel.dialog.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		MatDialogTitle,
		MatButton,
		MatDialogClose,
		MatIcon,
		CdkScrollable,
		MatDialogContent,
		ReactiveFormsModule,
		FmxFormSubmitDirective,
		SelectComponent,
		FmxControlSubmitDirective,
		SelectOptionTemplateDirective,
		TableComponent,
		FirestorePaginatorComponent,
		MatDialogActions,
		AsyncPipe,
		TranslatePipe,
	],
})
export class NotificationPanelDialog extends AbstractTableComponent<Notification> {
	protected readonly dialog: MatDialog
	protected readonly snackbarService: SnackbarService
	protected readonly authService: AuthService
	protected readonly dialogRef = inject<MatDialogRef<NotificationPanelDialog>>(MatDialogRef)
	readonly loadingService = inject<LoadingService>(LoadingService)

	readonly defaultSort: MatSortable = { id: 'createdAt', start: 'desc', disableClear: false }
	readonly sortSelection: Array<any> = [
		{ text: 'Cele mai noi', sort: { active: 'createdAt', direction: 'desc' } },
		{ text: 'Cele mai vechi', sort: { active: 'createdAt', direction: 'asc' } },
	]
	readonly omitHeaders: boolean = true
	readonly sortSelectionForm: UntypedFormGroup = new UntypedFormGroup({
		order: new UntypedFormControl(''),
	})
	pageSize: number = 5
	columns: Array<ColDef<Notification>> = [
		DateColumn({
			property: 'createdAt',
			label: 'obiect.creataLa',
			sortable: false,
			data: { format: 'dd.LL.yy HH:mm' },
		}),
		TextColumn({ property: 'data', label: 'obiect.mentiuni' }),
	]
	readonly defaultFilters: Array<FirestoreFilter> = []

	onSortSelect(event: OptionSelectedEvent<Sort>) {
		if (event.isUserInput) {
			super.onSort(event.value as Sort)
		}
	}

	constructor() {
		const firestoreService = inject<FirestoreService<Notification>>(NotificationsFirestoreService)
		const dialog = inject<MatDialog>(MatDialog)
		const snackbarService = inject<SnackbarService>(SnackbarService)
		const authService = inject<AuthService>(AuthService)

		super(firestoreService, dialog, snackbarService, authService)
		this.dialog = dialog
		this.snackbarService = snackbarService
		this.authService = authService

		this.sortSelectionForm.get('order')?.setValue('Cele mai noi')
		this.sortSelectionForm.updateValueAndValidity()
	}

	close(): void {}
}
